// Values must match the backend InvestorOnboardingStep enum
// (tallo-be/src/modules/investor/onboarding/investor-onboarding-step.enum.ts)
export enum InvestorOnboardingStep {
  AccountType = 'account_type',
  CompanyInfo = 'company_info',
  InviteTeam = 'invite_team',
  RentalStrategy = 'rental_strategy',
  ConnectCalendar = 'connect_calendar',
  Communication = 'communication',
}
